import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "container", "group"]
  static values = { map: Object }

  connect() {
    this.update()
  }

  categoryChanged(event) {
    if (event.target.dataset.autocompleteFieldKeyValue !== "vehicle_category_id") return

    this.update()
  }

  update() {
    const categoryKey = this.mapValue[String(this.selectTarget.value)]
    let visibleGroups = 0

    this.groupTargets.forEach(group => {
      const visible = group.dataset.categories.split(" ").includes(categoryKey)
      group.classList.toggle("d-none", !visible)
      if (visible) visibleGroups += 1
    })

    this.containerTarget.classList.toggle("d-none", visibleGroups === 0)
  }
}
